import { Container, Text } from '@mantine/core';
import { FC } from 'react';

interface DisclaimerFooterProps {
  disclaimer: string;
}

export const DisclaimerFooter: FC<DisclaimerFooterProps> = ({ disclaimer }) => {

  const paragraphs = disclaimer.split(/\n{2,}/);

  return (
    <div
      style={{
        backgroundColor: '#1F2021',
        color: '#80858F',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '10px',
        fontWeight: 500,
        lineHeight: 1.6,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Container
        size="lg"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          paddingInline: '0px',
        }}
      >

        {/* Render each paragraph dynamically */}
        {paragraphs.map((para, index) => (
          <Text
            key={index}
            style={{
              fontSize: '10px',
              fontWeight: 500,
              color: '#80858F',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            {para}
          </Text>
        ))}
      </Container>
    </div>
  );
};
